import React, {useEffect, useState} from 'react';


import {useLocation, useParams} from "react-router-dom";
import toFaNumber from "@/lib/utils/number";

import {Input, Tabs, Typography,} from 'antd';

import AdminLayout from "@/components/layout/admin/adminLayout";
import {URLS} from "@/lib/urls";

import {useApiReadAdminDiscounts} from "@/api/discount";

import DiscountMasterDetailSection from "@/pages/admin/discount/edit/[id]/_section/DiscountMasterDetailSection";
import RenderIf from "@/components/render-if";
import DiscountUsageSection from "@/pages/admin/discount/edit/[id]/_section/DiscountUsageSection";
import DiscountDedicateSection from "@/pages/admin/discount/edit/[id]/_section/DiscountDedicateSection";
import DiscountEventSection from "@/pages/admin/discount/edit/[id]/_section/DiscountEventSection";

const {Title, Text} = Typography;
const {TextArea} = Input;


function AdminDiscountEditPage() {

    const {id} = useParams();
    const {hash} = useLocation();

    const [myTab, setMyTab] = useState('edit')

    const {data: discountData, isPending, isSuccess, refetch} = useApiReadAdminDiscounts(id)

    const onChange = key => {
        setMyTab(key)
    };

    const items = [

        {key: 'edit', label: 'اطلاعات اصلی'},
        // {key: 'price', label: 'مبلغ و درصد تخفیف'},
        {key: 'dedicate', label: 'اختصاص به افراد'},
        {key: 'event', label: 'تنظیم رویداد'},
        {key: 'usage', label: 'موارد استفاده شده'},
    ]

    useEffect(() => {
        for (let tab in items) {

            if ('#' + items[tab].key === hash) {
                setMyTab(items[tab].key);
            }
        }
    }, [hash])


    return (
        <AdminLayout pageTitle={'ویرایش کد تخفیف' + ' #' + toFaNumber(id)} backTo={URLS.admin.discount.list}>


            <Tabs
                rootClassName={'mx-2'}
                type={'line'}
                defaultActiveKey="1"
                items={items}
                activeKey={myTab}

                onChange={onChange}/>

            <RenderIf condition={myTab === 'edit'}>
                <DiscountMasterDetailSection discountData={discountData} isSuccess={isSuccess} id={id}/>
            </RenderIf>
            <RenderIf condition={myTab === 'event'}>
                <DiscountEventSection discountData={discountData} id={id}/>
            </RenderIf>
            <RenderIf condition={myTab === 'dedicate'}>
                <DiscountDedicateSection id={id} discountData={discountData} refetch={refetch}/>
            </RenderIf>

            <RenderIf condition={myTab === 'usage'}>
                <DiscountUsageSection id={id} discountData={discountData}/>
            </RenderIf>


        </AdminLayout>
    );

}

export default AdminDiscountEditPage;
